import APPLY from '@/api/module/apply.js';

const applyCreate = {
  namespaced: true,
  state: {
    // 全部应用列表
    applyList: [],
  },
  mutations: {
    // 设置应用列表
    setapplyList(state, data = []) {
      state.applyList = data;
    },
  },
  actions: {
    // 新建应用
    // eslint-disable-next-line
    async newApply({ commit }, params) {
      try {
        await APPLY.createApply(params);
        return Promise.resolve('新建成功');
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 获取我的应用
    // eslint-disable-next-line
    async queryAllApply({ commit }, params) {
      try {
        const result = await APPLY.getAllApply(params);
        commit('setapplyList', result);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
  getters: {
    applyList: state => state.applyList,
  },
};

export default applyCreate;
